<template>
  <header
    :class="[
      'fixed inset-x-0 top-0 z-50 transition-all duration-300',
      scrolled ? 'border-b border-white/5 bg-[#060609]/80 backdrop-blur-xl' : 'border-b border-transparent',
    ]"
  >
    <nav class="page-shell flex items-center justify-between py-4">
      <a href="#top" class="flex items-center gap-3" @click.prevent="scrollToId('top')">
        <div>
          <p class="text-sm font-semibold text-white">Beiyi Data</p>
          <p class="text-xs text-[#8b8b99]">贝易科技</p>
        </div>
      </a>

      <div class="hidden items-center gap-8 md:flex">
        <button
          v-for="item in navItems"
          :key="item.id"
          type="button"
          class="text-sm text-[#8b8b99] transition-colors duration-200 hover:text-white"
          @click="scrollToId(item.id)"
        >
          {{ t(item.label) }}
        </button>
        <div class="flex items-center gap-1 rounded-md border border-white/10 bg-white/[0.03] p-1">
          <button
            v-for="item in locales"
            :key="item"
            type="button"
            class="rounded px-2 py-1 text-xs transition-colors duration-150"
            :class="locale === item ? 'bg-white/15 text-white' : 'text-[#8b8b99] hover:text-white'"
            @click="setLocale(item)"
          >
            {{ localeNames[item] }}
          </button>
        </div>
        <a
          href="mailto:beibei@beiyidata.cn"
          target="_blank"
          rel="noopener noreferrer"
          class="rounded-md border border-white/15 px-4 py-2 text-sm text-white transition-colors duration-200 hover:bg-white/10"
        >
          {{ t(ctaText) }}
        </a>
      </div>

      <button
        type="button"
        class="inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-white md:hidden"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click="menuOpen = !menuOpen"
      >
        <span class="flex flex-col gap-1.5">
          <span class="block h-px w-5 bg-current"></span>
          <span class="block h-px w-5 bg-current"></span>
          <span class="block h-px w-5 bg-current"></span>
        </span>
      </button>
    </nav>

    <transition name="fade">
      <div v-if="menuOpen" class="fixed inset-0 bg-[#060609]/96 px-6 py-8 md:hidden">
        <div class="flex h-full flex-col">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-semibold text-white">Beiyi Data</p>
              <p class="text-xs text-[#8b8b99]">贝易科技</p>
            </div>
            <button
              type="button"
              class="inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-white"
              aria-label="Close navigation"
              @click="menuOpen = false"
            >
              X
            </button>
          </div>

          <div class="mt-16 space-y-6">
            <button
              v-for="item in navItems"
              :key="item.id"
              type="button"
              class="block text-left text-3xl font-semibold text-white"
              @click="handleMobileNav(item.id)"
            >
              {{ t(item.label) }}
            </button>
          </div>
          <div class="mt-8 flex flex-wrap gap-2">
            <button
              v-for="item in locales"
              :key="item"
              type="button"
              class="rounded-md border border-white/10 px-3 py-1.5 text-xs"
              :class="locale === item ? 'bg-white/15 text-white' : 'text-[#8b8b99]'"
              @click="setLocale(item)"
            >
              {{ localeNames[item] }}
            </button>
          </div>

          <a
            href="mailto:beibei@beiyidata.cn"
            target="_blank"
            rel="noopener noreferrer"
            class="mt-auto inline-flex w-full items-center justify-center rounded-md border border-white/15 px-4 py-3 text-sm text-white"
          >
            {{ t(ctaText) }}
          </a>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from '../composables/useI18n'

const navItems = [
  {
    id: 'products',
    label: { zh: '产品', en: 'Products', es: 'Productos', fr: 'Produits', ja: '製品' },
  },
  {
    id: 'about',
    label: { zh: '关于', en: 'About', es: 'Nosotros', fr: 'À propos', ja: '会社情報' },
  },
  {
    id: 'contact',
    label: { zh: '联系', en: 'Contact', es: 'Contacto', fr: 'Contact', ja: '連絡先' },
  },
]
const ctaText = {
  zh: '联系我们',
  en: 'Get in Touch',
  es: 'Contáctanos',
  fr: 'Nous contacter',
  ja: 'お問い合わせ',
}

const menuOpen = ref(false)
const scrolled = ref(false)
const { locale, locales, localeNames, setLocale, t } = useI18n()

const handleScroll = () => {
  scrolled.value = window.scrollY > 80
}

const scrollToId = (id) => {
  const target = document.getElementById(id)
  if (!target) {
    return
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const handleMobileNav = (id) => {
  menuOpen.value = false
  window.setTimeout(() => scrollToId(id), 40)
}

onMounted(() => {
  handleScroll()
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
